import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: classNames.ArgumentArray) {
    return twMerge(classNames(inputs));
}

export function getAvatarFallbackName(fullname?: string) {
    if (!fullname) return '';
    const names = fullname.trim().split(' ');

    if (names.length === 1) {
        return `${names[0].charAt(0).toUpperCase()}${names[0].charAt(1).toUpperCase()}`;
    } else if (names.length > 1) {
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }

    return '';
}

export function handleLongText(text: string, numAccept: number): string {
    let finalText = text;
    const length = text.length;
    if (length <= numAccept * 2) return text;
    const head = text.slice(0, numAccept);
    const indexDomain = text.lastIndexOf('@');
    let foot = text.slice(indexDomain - numAccept, length);
    if (foot.length >= 25) {
        const temp = foot;
        const indexDot = temp.lastIndexOf('.');
        foot = temp.slice(indexDot - numAccept, temp.length);
    }
    finalText = head + ' ... ' + foot;
    return finalText;
}
